"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var IST = _interopRequireWildcard(require("./subTypes"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var INCOME_NON_EMPLOYMENT_SUB_TYPES = [IST.BUSINESS_PROFESSIONAL_FARM, IST.PROPERTY_RENTAL, IST.INTERESTS_DIVIDENDS_ROYALTIES, IST.FAMILY_SUPPORT, IST.ALIMONY, IST.HOUSEHOLD_CONTRIBUTIONS, IST.OUTSIDE_CONTRIBUTORS, IST.UNEMPLOYMENT, IST.SOCIAL_SECURITY, IST.SUPPLEMENTAL_SECURITY_INCOME, IST.SUPPLEMENTAL_SECURITY_INCOME_FOR_CHILDREN, IST.SOCIAL_SECURITY_DISABILITY_INSURANCE, IST.SNAP, IST.TANF, IST.SECTION_8, IST.LIFELINE_PHONE, IST.LIHEAP, IST.CHIP, IST.DISABILITY, IST.PENSION_RETIREMENT, IST.VA_DISABILITY, IST.OTHER_GOVERNMENT_ASSISTANCE, IST.OTHER];
var _default = INCOME_NON_EMPLOYMENT_SUB_TYPES;
exports["default"] = _default;